// extracted by mini-css-extract-plugin
export var addButton = "_5v-d";
export var bullets = "_5v-e";
export var compact = "_5v-2";
export var container = "_5v-j";
export var extendedWarrantyModal = "_5v-f";
export var learn = "_5v-l";
export var learnMore = "_5v-g";
export var offeringOption = "_5v-3";
export var offeringPrice = "_5v-8";
export var offeringSubtitle = "_5v-7";
export var offeringTitle = "_5v-6";
export var offeringsContainer = "_5v-0";
export var pdpTilesBackground = "_5v-n";
export var plan = "_5v-m";
export var regular = "_5v-1";
export var remove = "_5v-k";
export var seeDetailsIcon = "_5v-i";
export var seeDetailsLink = "_5v-h";
export var selectedOption = "_5v-4";
export var shieldIcon = "_5v-b";
export var shieldIconCompact = "_5v-c";
export var subtitle = "_5v-a";
export var title = "_5v-9";
export var unselectedOption = "_5v-5";